import React, { useCallback, useMemo } from "react";
import cx from "classnames";
import {
  ExpandedDetailedOptionsCard,
  rakValuePackagePlusName
} from "./ExpandedOptionsCards/ExpandedDetailedOptionsCard";
import { rakValuesList } from "./ExpandedOptionsCards/constants";
import { accountNames } from "../../../../constants";
import {
  RAK_VALUE_PACKAGE_PATH,
  WOMEN_ENTERPRENEURSHIP_TERMS_AND_CONDITIONS_URL
} from "./constants";

import { useStyles } from "./styled";
import { GA_EVENTS } from "../../../../utils/ga";

const getButtonText = ({ _id, options, accountCurrencies, rakValuePackage, accountType }) => {
  const { isSelectOnlyForeignCurrency } = accountCurrencies;
  if (isSelectOnlyForeignCurrency) {
    return options.disabledLabelForForeignCurrency;
  }

  if (rakValuePackage) {
    if (rakValuePackage === options._id) {
      return options.buttonLabel;
    }
    return options.notSelectedLabel;
  }

  if (accountType === accountNames.starter) {
    if (_id === rakValuePackagePlusName) {
      return options.buttonLabel;
    }
    return options.notSelectedLabel;
  } else {
    return options.notSelectedLabel;
  }
};

export const ValueAddedServicesComponent = ({
  accountType,
  readMoreUrls,
  updateProspect,
  rakValuePackage,
  accountCurrencies
}) => {
  const { isSelectOnlyForeignCurrency } = accountCurrencies;
  const classes = useStyles();

  const handleSelectValue = useCallback(
    selectedService => {
      const serviceName =
        rakValuePackage === selectedService && accountType !== accountNames.starter
          ? ""
          : selectedService;
      updateProspect(
        {
          [RAK_VALUE_PACKAGE_PATH]: serviceName
        },
        GA_EVENTS.SELECT_SERVICE_KEEP_PLUS_UPGRADE_CONTINUE
      );
    },
    [rakValuePackage, accountType, updateProspect]
  );

  const isRAKstarter = useMemo(() => accountType === accountNames.starter, [accountType]);

  return (
    <>
      <div className={cx(classes.formWrapper, { [classes.disabled]: isSelectOnlyForeignCurrency })}>
        {rakValuesList.map(({ optionList, isIncluded, cost, value, _id }, index) => (
          <ExpandedDetailedOptionsCard
            key={value}
            value={value}
            id={_id}
            isSelected={value === rakValuePackage && !isSelectOnlyForeignCurrency}
            buttonLabel={getButtonText({
              _id,
              options: rakValuesList[index],
              accountCurrencies,
              rakValuePackage,
              accountType
            })}
            handleClick={handleSelectValue}
            disabled={isSelectOnlyForeignCurrency}
            optionList={optionList}
            isIncluded={isIncluded}
            cost={cost}
            readMoreUrls={readMoreUrls}
            accountType={accountType}
            className={classes.cardsWrapper}
            selectService
            isRAKstarter={isRAKstarter}
          />
        ))}
      </div>
      {!isSelectOnlyForeignCurrency && accountType === accountNames.starter && !rakValuePackage && (
        <p className={cx(classes.disabledReasonInfo, classes.danger)}>
          *Selecting a Value Package can help save on your banking costs. Please select one to
          continue the account application and enjoy the benefits!
        </p>
      )}

      {isSelectOnlyForeignCurrency && (
        <p className={classes.disabledReasonInfo}>
          You have selected foreign currencies for your accounts. RAKvalue packages are only
          eligible for AED accounts
        </p>
      )}

      {isRAKstarter && (
        <p
          className={classes.womensDaySpclOfferTermsCondWrapper}
          data-testid="womens-day-offer-terms-conditions"
        >
          <sup className={classes.spclPackageSupscript}>†</sup> Eligibility Criteria
          <ol className={classes.womensDaySpclOfferTermsCond}>
            <li>Offer valid for New to Bank (NTB) female entrepreneurs only.</li>
            <li>
              Applicable only for accounts opened between <b>10th May 2026</b> and{" "}
              <b>10th December 2026</b>.
            </li>
            <li>
              Eligibility requires 100% female ownership as a sole proprietor or individual LLC.
            </li>
            <li>
              Waiver applies only to RAKStarter account maintenance fee and RAKvalue SME Plus
              package monthly subscription fee for 12 months from the date of account opening.
            </li>
            <li>Waiver ends automatically if customer changes the package or account type.</li>
            <li>
              Please{" "}
              <a
                className={classes.women_tandC_link}
                target="_blank"
                rel="noopener noreferrer"
                href={WOMEN_ENTERPRENEURSHIP_TERMS_AND_CONDITIONS_URL}
              >
                click here
              </a>{" "}
              to view the Terms and Conditions.
            </li>
          </ol>
        </p>
      )}
    </>
  );
};
